/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M11.956 3c2.483 0 4.89.451 7.148 1.43.677.3 1.128.978 1.203 1.655v5.492a9.679 9.679 0 0 1-6.395 8.953l-.827.3a3.6 3.6 0 0 1-2.182 0l-.828-.3c-3.837-1.355-6.395-4.89-6.395-8.953V6.085c0-.677.452-1.355 1.129-1.656C7.066 3.451 9.473 3 11.956 3Zm-2.2 12.69c.2.2.45.3.75.3h.05c.3-.05.6-.2.75-.45l5.5-7c.35-.45.2-1.05-.25-1.35-.45-.35-1.05-.2-1.4.3l-4.8 5.95-1.65-1.8c-.35-.4-1-.4-1.4-.05-.4.35-.4 1-.05 1.4l2.5 2.7Z"
})), "0 0 24 24", "InsuranceConfirmed");